import type { ActionType } from 'typesafe-actions';

import * as actions from '../actions/decisionListActions';
import { DecisionListActionsEnum } from '../enums/DecisionListActionsEnum';
import { IDecisionListState } from '../interfaces/IDecisionListState';

export type DecisionListAction = ActionType<typeof actions>;

const initialState: IDecisionListState = {
  data: [],
  findData: [],
  page: 0,
  pageCount: 0,
  totalCount: 0,
  rejected: 0,
  order: null,
};

export function decisionListReducer(state = initialState, action: DecisionListAction) {
  switch (action.type) {
    case DecisionListActionsEnum.DECISION_LIST_SET_DATA: {
      const { data, page, totalCount, pageCount, rejected } = action.payload;
      const newState: IDecisionListState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
        rejected,
      };

      return newState;
    }
    case DecisionListActionsEnum.DECISION_LIST_SET_ORDER: {
      const { order } = action.payload;
      const newState: IDecisionListState = {
        ...state,
        order,
      };

      return newState;
    }
    case DecisionListActionsEnum.DECISION_LIST_SET_SEARCH_VALUE: {
      const { searchValue, filterParam } = action.payload;
      const newState: IDecisionListState = {
        ...state,
        searchValue,
        filterParam,
      };

      return newState;
    }
    case DecisionListActionsEnum.DECISION_LIST_SET_FIND_DATA: {
      const { findData } = action.payload;
      const newState: IDecisionListState = {
        ...state,
        findData,
      };

      return newState;
    }
    default:
      return state;
  }
}
